import { MenuModalComponent } from './../../components/menu-modal/menu-modal.component';
import { PersonalizeProductComponent } from '../../components/personalize-product/personalize-product';
import { Component, ViewChild, ElementRef } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, ToastController, MenuController } from 'ionic-angular';
import { FamilyService } from '../../providers/family/family.service';
import { ProductService } from '../../providers/product/product.service';
import { MenuService } from '../../providers/menu/menu.service';
import { OrdersService } from '../../providers/order/orders.service';
import { PdvService } from '../../providers/pdv/pdv.service';
import { Subscription } from 'rxjs/Subscription';

@IonicPage()
@Component({
  selector: 'page-carte',
  templateUrl: 'carte.html',
})

export class CartePage {
  loading: boolean = false;
  loadMenus: boolean[] = [];
  options: any;
  compositions: any[] = [];
  itemsCompositions: any[] = [];
  selectedCompForSearch: any[] = [];
  searchElement: String = "";
  families: any[] = [];
  menucategories: any[] = [];
  activeTab = 1;
  products: any[] = [];
  menus: any[] = [];
  familyActive = -2;
  menuCategoryActive = -2;
  idPdv: string;
  orderTypes: any[];
  orderType: number;
  chosenOrderType: number;
  close: boolean = false;
  nbrOffersAuthorizedSite: number;
  offerNbr: number;
  menuTime: number;
  selectedComp = [];
  siteClose: boolean = false;
  displayBestSales = false;
  subscriptions: Subscription[] = [];
  @ViewChild('scrollTap') scrollTap: ElementRef
  selectedTabs: number = -2;
  menuTabs = false;
  elementsNbr = 0;
  @ViewChild('scrollTap2') scrollTap2: ElementRef;
  @ViewChild('myContent') myContent: ElementRef;
  firstrun = 1;
  animation: boolean = false;
  displayBestOffers = false;
  title1: string = '';
  discount: number = 0;
  discountFrom: number = 0;
  siteCloseComment = "";
  orderProg;
  fromOrder = false;
  alert = "";
  alertclose = false;
  pdvIdDis : any;
  currency = "€";
  language = localStorage.getItem('language');
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private familyService: FamilyService,
    private productService: ProductService,
    private menuService: MenuService,
    private orderService: OrdersService,
    private pdvService: PdvService,
    public modalCtrl: ModalController,
    private toastCtrl: ToastController,
    private menuCtrl: MenuController
  ) {
    this.currency = localStorage.getItem('currency');
    const subs9 = this.orderService.orderProg.subscribe((orderProg) => {
      this.orderProg = orderProg;
    });
    const subs = this.orderService.elementsNbr.subscribe(elementsNbr => {
      setTimeout(() => {
        if (elementsNbr > this.elementsNbr) {
          this.animation = true;
          this.elementsNbr = elementsNbr;
        }
        setTimeout(() => {
          this.animation = false;
        }, 500)
      }, 500)
    });
    this.pdvService.pdv.subscribe(
      (data) => {
        this.siteClose = data.closeSite;
        this.siteCloseComment = data.closeComment;
        this.alert = data.alert;
        this.discount = data.discount;
        this.discountFrom = data.discountFrom;
        this.pdvIdDis = data.idPdv;
      }
    )
    this.pdvService.getPdvInfo().subscribe(
      (pdv: any) => {
        if (pdv) {
          this.displayBestSales = pdv.displayBestSales;
          this.orderService.orderType.subscribe((orderType: number) => {
            this.menuService.getOffers(orderType, this.orderProg).toPromise().then(
              (offers: any[]) => {
                if (offers.length > 0) {
                  this.displayBestOffers = pdv.displayBestOffers;
                } else {
                  this.displayBestOffers = false;
                }
              }
            )
          })
        }
      }
    )

    const subs2 = this.orderService.chosenOrderType.subscribe((chosenOrderType: number) => {
      this.chosenOrderType = chosenOrderType;
      // if (this.chosenOrderType == 0) {
      //   this.navCtrl.setRoot('OrderTypePage');
      // }
    });
    const subs3 = this.pdvService.orderTypes.subscribe((orderTypes: any[]) => {
      this.orderTypes = orderTypes;
    });
    const subs5 = this.pdvService.nbrOffersAuthorizedSite.subscribe((nbrOffersAuthorizedSite: number) => {
      this.nbrOffersAuthorizedSite = nbrOffersAuthorizedSite;
    });
    const subs7 = this.orderService.offerNbr.subscribe((offerNbr: any) => {
      this.offerNbr = offerNbr;
    });
    const subs6 = this.orderService.menuTime.subscribe((menuTime: any) => {
      this.menuTime = menuTime;
    });
    const subs4 = this.orderService.orderType.subscribe((orderType: number) => {
      this.orderType = orderType;
      if (this.orderTypes.length >= 1 && orderType > 0) {
        this.title1 = this.orderTypes.filter(o => o.id == orderType)[0].label
      }
    })
    this.getFamiliesOfCarte();
    this.getMenuCategoriesOfCarte();
    this.subscriptions.push(subs2, subs3, subs4, subs5, subs6, subs7, subs9);
  }

  ionViewDidEnter() {

  }
  ngOnInit() {
    this.pdvService.orderTypes.subscribe((orderTypes: any[]) => {
      this.orderService.chosenOrderType.subscribe((chosenOrderType: number) => {
        if (orderTypes.length >= 1 && chosenOrderType > 0) {
          this.title1 = orderTypes.filter(o => o.id == chosenOrderType)[0].label
        }
      });
    });
    setTimeout(() => {
      if (this.navParams.get('from') == "filter") {
        this.selectedTabs = -4;
        const subs4 = this.orderService.selectedComp.subscribe(
          s => {
            if (s.length > 0) {
              this.changedCompositions(s)
            } else {
              this.getProducts(0);
            }
          }
        )
      } else {
        this.fromOrder = this.navParams.get('fromOrder');
        let isMenu = this.navParams.get('isMenu');
        let index = this.navParams.get('index');
        if (index>=0) {
          if (isMenu) {
            this.menuTabs = true;
            this.getMenus(index);
          } else {
            this.getProducts(index);
          }
        } else {
          if (this.fromOrder) {
            this.menuTabs = this.navParams.get('menuTabs');
            this.selectedTabs = this.navParams.get('selectedTabs');
            if (this.menuTabs) {
              this.getMenus(this.selectedTabs);
            } else {
              this.getProducts(this.selectedTabs);
            }
          } else {
            if (this.displayBestSales) {
              this.getProducts(-1);
            } else {
              this.getProducts(0);
            }
          }
        }
      }
    }, 500)
  }

  goToBasket() {
    if (this.elementsNbr > 0) this.navCtrl.setRoot('CheckoutPage');
  }
  changedCompositions(selectedComp) {
    this.loading = true;
    if (selectedComp.length > 0) {
      this.productService.getElementByCompositions(selectedComp, this.orderType, this.orderProg).subscribe(
        (products: any[]) => {
          this.products = products;
          this.loading = false;
          if (products.length == 0) {
            this.displayMessage('Aucun produit disponible');
            this.getProducts(this.selectedTabs);
            this.orderService.selectedComp.next([]);
          }
        }
      )
    } else {
      this.products = [];
    }
  }
  getFamiliesOfCarte() {
    this.familyService.families.subscribe(
      (families: any[]) => {
        this.families = families;
        this
        if (this.firstrun <= 2) {
          setTimeout(
            () => {
              this.firstrun++;
            }, 100
          )
        }
      }
    )
  }

  getMenuCategoriesOfCarte() {
    this.familyService.menucategories.subscribe(
      (menucategories: any[]) => {
        this.menucategories = menucategories;
      }
    )
  }

  getProducts(i) {
    this.loading = true;
    this.products = [];
    this.selectedTabs = i;
    this.setActiveTAb();
    if (i > -1) {
      return this.productService.getActiveProductByFamily(this.families[i].id, this.orderType, this.orderProg).toPromise().then(
        (data: any[]) => {
          this.loading = false;
          this.products = data;
        }
      );
    } else {
      if (i == -1) {
        return this.productService.getBestSales(this.orderType, this.orderProg).toPromise().then(
          (products: any[]) => {
            this.loading = false;
            this.products = products;
          }
        )
      }
      if (i == -2) {
        this.menuService.getOffers(this.orderType, this.orderProg).subscribe(
          (offers: any[]) => {
            this.loading = false;
            this.menus = offers;
          }
        )
      }
    }
  }

  getMenus(i) {
    this.loading = true;
    this.menus = [];
    this.selectedTabs = i;
    this.setActiveTAb();
    this.menuService.getMenusOfCategory(this.menucategories[i].id, this.orderType, this.orderProg).toPromise().then(
      (menus: any[]) => {
        this.menus = menus;
        this.loading = false;
      }
    )
  }

  setActiveTAb() {
    setTimeout(
      () => {
        var outerContent = (this.menuTabs) ? this.scrollTap2.nativeElement : this.scrollTap.nativeElement;
        var innerContent = <HTMLElement>document.getElementsByClassName('activeTab')[0];
        if (innerContent) {
          const pos = (outerContent.offsetWidth - innerContent.offsetWidth) / 2;
          outerContent.scroll({ left: this.absoluteOffset(innerContent) - pos, top: 0, behavior: 'smooth' });
        }
      }, 100
    )
  }

  absoluteOffset(elem) {
    return elem.offsetParent && elem.offsetLeft + this.absoluteOffset(elem.offsetParent);
  }

  setMenuTabs() {
    this.menuTabs = true;
    this.selectedTabs = 0;
    this.getMenus(0);
  }

  setFamilyTabs() {
    this.menuTabs = false;
    this.selectedTabs = -1;
    this.getProducts(0);
  }

  ngAfterViewInit() {
    this.myContent.nativeElement.addEventListener('scroll', event => {
      let scrollTop = this.myContent.nativeElement.scrollTop;
      var outerContent = (this.menuTabs) ? this.scrollTap2.nativeElement : this.scrollTap.nativeElement;
      if (scrollTop > 0) {
        outerContent.classList.add('steakyTab')
      } else {
        outerContent.classList.remove('steakyTab')
      }
    })
  }

  addElementToBasket(i) {
    if (this.chosenOrderType == 0) {
      this.navCtrl.setRoot('OrderTypePage', { menuTabs: this.menuTabs, selectedTabs: this.selectedTabs, fromOrder: true });
    } else {
    let product = this.products[i];
    let element = {
      id: product.id,
      code: product.code,
      name: product.name,
      family: product.family,
      size: product.sizes[product.size],
      comment: '',
      qty: 1,
      removedCompositions: [],
      supplements: [],
      optionIngredients: [],
      total: 0,
      vat: product.vat,
      priceSuppApp: product.priceSuppApp,
      priceWithSupp: Number(product.sizes[product.size].price),
      maxNbrIngOptions: product.maxNbrIngOptions,
      hasSupp: product.hasSupp,
      avatar: product.avatar
    }
    element.total += Number(element.size.price);
    element.total *= Number(element.qty);
    this.orderService.addElementToOrder(element);
  }
}

  OpenMenuModal(i) {
    if (this.chosenOrderType == 0) {
      this.navCtrl.setRoot('OrderTypePage', { menuTabs: this.menuTabs, selectedTabs: this.selectedTabs, fromOrder: true });
    } else {
      if (this.menus[i].offer == null || (this.menus[i].offer != null && this.offerNbr < this.nbrOffersAuthorizedSite)) {
        let modal = this.modalCtrl.create(MenuModalComponent, { menu: this.menus[i] });
        modal.present();
      } else {
        this.displayMessage('Vous avez atteint le nombre d\'offre autorisée')
      }
    }

  }

  displayMessage(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: 'top'
    });
    toast.present();
  }

  PersonalizeModal(i) {
    if (this.chosenOrderType == 0) {
      this.navCtrl.setRoot('OrderTypePage', { menuTabs: this.menuTabs, selectedTabs: this.selectedTabs, fromOrder: true });
    } else {
      let product = this.products[i];
      let personnaliseProduct = this.modalCtrl.create(PersonalizeProductComponent, { product: product });
      personnaliseProduct.present();
    }

  }

  setNewOrderType() {
    this.navCtrl.setRoot('OrderTypePage', { menuTabs: this.menuTabs, selectedTabs: this.selectedTabs, fromOrder: true });
  }

  toggleMenu() {
    this.menuCtrl.enable(true, 'menu1');
    this.menuCtrl.enable(false, 'menu2');
    this.menuCtrl.toggle();
  }
  openFilter() {
    this.menuCtrl.enable(true, 'menu2');
    this.menuCtrl.enable(false, 'menu1');
    this.menuCtrl.toggle();
  }
}


// WEBPACK FOOTER //
// ./src/pages/carte/carte.ts